/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2023 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2023 - Finnish Meteorological Institute (FMI)
 * Copyright 2024 - The Norwegian Meteorological Institute (MET Norway)
 * */

import React from 'react';
import { useSelector } from 'react-redux';
import TimeSeriesServiceList from './TimeSeriesServiceList';
import {
  getAllFilterChipsEnabled,
  getServiceFilterChips,
} from '../../store/selectors';
import type {
  ServiceFilterChipsObjectEntities,
  TimeSeriesRootState,
} from '../../store/types';

export const sortByService = (
  serviceObj: ServiceFilterChipsObjectEntities,
): ServiceFilterChipsObjectEntities =>
  Object.entries(serviceObj)
    .sort(([, serviceA], [, serviceB]) =>
      serviceA!.serviceName!.localeCompare(serviceB?.serviceName!),
    )
    .reduce((result, [key, value]) => ({ ...result, [key]: value }), {});

interface TimeSeriesServiceListConnectProps {
  panelId: string;
}

const TimeSeriesServiceListConnect: React.FC<
  TimeSeriesServiceListConnectProps
> = ({ panelId }: TimeSeriesServiceListConnectProps) => {
  const filterChipsServices = useSelector((store: TimeSeriesRootState) =>
    getServiceFilterChips(store, panelId),
  );

  const isAllFilterchipsEnabled = useSelector((store: TimeSeriesRootState) =>
    getAllFilterChipsEnabled(store, panelId),
  );

  return (
    <TimeSeriesServiceList
      filterChipsServicesById={sortByService(filterChipsServices)}
      isAllSelected={isAllFilterchipsEnabled}
      panelId={panelId}
    />
  );
};

export default TimeSeriesServiceListConnect;
